export default {
	state: {
		clientPopup: {
			client_id: null,
			show: false,
		},
	},

	// = updates the state
	// -> Mutation always updates the state.
	mutations: {
		OPEN_CLIENT_POPUP(state, clientId)
		{
			state.clientPopup.show = true;
			state.clientPopup.client_id = clientId;
		},

		CLOSE_CLIENT_POPUP(state)
		{
			state.clientPopup.show = false;
			state.clientPopup.client_id = null;
		},
	},

	actions: {},
	getters: {},
}
